const PT = require("prop-types");
const _ = require("lodash");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const Link = require("./Link");
const URLMake = require("../../../shared/URLMake");
const {getBaseInstance} = require("../util/HOCUtil");

/*
	An arbitrary link to another part of the page (or another view of the single page
	app). Unlike standard <a href>,	clicking this link does not trigger a page reload.

	Where Link can be used for anything, StudentLink should be used on student-facing
	pages. Additionally, StudentLink will determine whether the user is currently on
	a demo page and will automatically adjust the URL for the target page.

	===========================
	NOTE:
		When supplying the "to" prop, a page state object is preferred, but you can use
		a URL string for the time being.
	===========================
*/

const getPropsFromVault = function(props, vaultState) {
	return {
		demo: !!vaultState.page.demo,
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component, getPropsFromVault, {});
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "StudentLink",

		propTypes: {
			// path of the route to link to. SEE NOTE ABOVE
			to: PT.oneOfType([PT.string, PT.object]),

			// Passed through to Link (e.g. WonkyButton with linkTo + isNewTab).
			isNewTab: PT.bool,

			// Inject by HOC
			// If true, this should link to a demo page (will get demo prepended to url)
			demo: PT.bool,
		},

		getTo: function(to) {
			if (to) {
				if (this.props.demo) {
					return typeof to === "string"
						? URLMake.forDemoFromBaseUrl(to)
						: URLMake.forDemo(to);
				} else {
					return typeof to === "string" ? to : URLMake.forPageState(to);
				}
			}
		},

		click: function(evt) {
			if (_.isFunction(this?.linkRef?.click)) {
				this.linkRef.click();
			}
		},

		render: function() {
			const linkProps = _.clone(this.props);
			linkProps.to = this.getTo(this.props.to);
			return (
				<Link
					ref={link => (this.linkRef = getBaseInstance(link))}
					{...linkProps}
				/>
			);
		},
	})
);
